import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import PageTemplate from '../../components/Common/PageTemplate';

const OgretimUyemizZoologyDergisiBasEditor = () => {
  return (
    <PageTemplate
      title="Öğretim Üyemiz Zoology in the Middle East Dergisine Baş Editör Seçilmiştir"
      subtitle=""
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl -mt-16 relative z-10 mb-16">

          <div className="flex flex-col lg:flex-row gap-10 items-start">
            {/* Fotoğraf */}
            <div className="lg:w-1/4 flex-shrink-0">
              <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-100">
                <img
                  src="https://fs.hacettepe.edu.tr/fenyeni/resimler/_/_2/b1.jfif"
                  alt="Doç. Dr. Baran Yoğurtçuoğlu"
                  className="w-full h-auto object-cover"
                  loading="eager"
                />
              </div>
            </div>

            <div className="lg:w-3/4 space-y-5">
              {/* Dergi Adı ve Kişi */}
              <div>
                <p className="text-2xl font-bold text-hacettepe-blue italic">Zoology in the Middle East</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  <span className="px-4 py-1.5 rounded-full text-sm font-semibold bg-hacettepe-red text-white">
                    Doç. Dr. Baran Yoğurtçuoğlu
                  </span>
                  <span className="px-4 py-1.5 rounded-full text-sm font-semibold bg-blue-600 text-white">
                    Baş Editör
                  </span>
                  <span className="px-4 py-1.5 rounded-full text-sm font-semibold bg-emerald-600 text-white">
                    Taylor &amp; Francis
                  </span>
                </div>
              </div>

              {/* Metin */}
              <p className="text-lg leading-relaxed text-gray-700">
                Fakültemiz Biyoloji Bölümü Öğretim Üyesi Doç. Dr. Baran Yoğurtçuoğlu, Taylor &amp; Francis tarafından yayımlanan "Zoology in the Middle East" dergisinde baş editör olarak görevlendirildi.
              </p>
              <p className="text-lg leading-relaxed text-gray-700">
                Zoology in the Middle East dergisi, aralarında Web of Science (SCI) indeksinin de bulunduğu çok sayıda uluslararası veri tabanı tarafından taranmaktadır. Dergi, uzun yıllardır alanında yayın yapan, saygın ve köklü bir uluslararası bilimsel dergi olarak, başta Batı Asya olmak üzere Palearktik bölgenin büyük bir kısmını kapsayan coğrafyada; hayvan biyolojisi, taksonomi, biyocoğrafya, ekoloji, evrimsel biyoloji ve koruma biyolojisi alanlarında yürütülen özgün bilimsel çalışmaları yayımlamaktadır. Zoology in the Middle East, bölgenin zengin faunal çeşitliliğini, ekolojik örüntülerini ve biyolojik mirasını bilim dünyasına aktarmayı ve bu doğrultuda koruma ve sürdürülebilirlik çalışmalarına güçlü bir bilimsel zemin oluşturmayı amaçlamaktadır.
              </p>
            </div>
          </div>

        </div>

        <div className="text-center mb-16">
          <Link
            to="/haberler"
            className="group inline-flex items-center px-8 py-4 bg-gradient-to-r from-gray-800 to-gray-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-gray-300"
          >
            <FaArrowLeft className="mr-3 -ml-1 h-5 w-5 group-hover:-translate-x-1 transition-transform duration-300" />
            Tüm Haberlere Geri Dön
          </Link>
        </div>
      </div>
    </PageTemplate>
  );
};

export default OgretimUyemizZoologyDergisiBasEditor;
